import url from "url";
import queryString from "query-string";

export const parseQuery = (urlParams) => {
  let parseUrl = url.parse(urlParams);
  return  queryString.parse(parseUrl.query);
};
